<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { AppTypography } from '~/components/base';
import useGetTermsOfUse from '~/composables/useGetTermsOfUse';
import TermsOfUsePageContent from '~/utils/contents/pages/TermsOfUsePage';
import { $sanitizeHtml } from '~/utils/helpers';

const { termsOfUse, getTermsOfUse } = useGetTermsOfUse();

const sanitizedTermsOfUse = computed(() => $sanitizeHtml(termsOfUse.value));

onMounted(() => {
  getTermsOfUse();
});
</script>

<template>
  <div class="terms-of-use-page__content border bg-white p-6 md:p-10 lg:p-16">
    <AppTypography type="title-6" class="mb-8 text-center">
      {{ TermsOfUsePageContent.title }}
    </AppTypography>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="richtext" v-html="sanitizedTermsOfUse"></div>
  </div>
</template>
